<template>
    <div class="customer__form modal modal--default">
        <div class="modal__panel"
            :class="{ 'modal__panel--table': currentStep === 3 && offerId == 2, 'modal__panel--questions': currentStep === 3 && offerId == 1 }">
            <div class="modal__main-icon modal__main-icon--offer"></div>
            <div class="modal__back" @click="goBack()"></div>
            <div class="modal__close" @click="closeModal()"></div>

            <div class="form form--terminate">
                <div class="navigators" v-if="!formLoading">
                    <div class="navigator navigator--active">
                        <div class="navigator__bullet"></div>
                        <div class="navigator__title">
                            {{ isEditing ? $t(`addOfferModal.${"editTitle"}`) : $t(`addOfferModal.${"title"}`) }}
                        </div>
                    </div>
                </div>
                <div class="add__form">
                    <transition name="fade" mode="out-in">
                        <Loading v-if="formLoading" />
                        <div v-else class="add__content">
                            <div class="form">
                                <div class="form__row form-selection-row" v-if="currentStep === 1 && !isEditing">
                                    <div class="form__field">
                                        <label class="form__label subtitle-label">
                                            {{ $t(`addOfferModal.selectOfferType`) }}
                                        </label>
                                        <VSelect class="select select--default"
                                            :placeholder="$t(`addOfferModal.selectOfferPlaceholder`)" :options="offers"
                                            :reduce="(offer) => offer.id" :getOptionLabel="(offer) => `${offer.name}`"
                                            v-model="offerId" @input="getQuestions($event)" />
                                    </div>
                                </div>

                                <div class="questions-wrapper" v-if="currentStep === 2">
                                    <div class="driver-info">
                                        <div class="form__row customer-name-row">
                                            <div class="form__field computed-name-field">
                                                <p class="modal__title offer-subtitle">
                                                    {{ $t(`addOfferModal.policyHolder`) }}
                                                </p>
                                                <div class="input input--default input--readonly">
                                                    {{ parseCustomerName(customerDetails) }}
                                                </div>
                                            </div>

                                            <div class="form__field">
                                                <p class="form__label subtitle-label offer-subtitle"> {{
                                                    $t(`addOfferModal.policyCalculate`) }}</p>
                                                <VSelect class="select select--default" :options="agents"
                                                    :reduce="(agent) => agent.id"
                                                    :getOptionLabel="(agent) => `${agent.first_name} ${agent.last_name}`"
                                                    v-model="policyHolder.agent_id"
                                                    :placeholder="$t(`addOfferModal.assignedTo`)" />
                                            </div>

                                            <div v-if="offerId == 1" class="form__field checkbox-field second-driver">
                                                <label class="details__option-checkbox" for="secondDriver">
                                                    {{ $t(`addOfferModal.frequentDriver`) }}
                                                </label>
                                                <div class="checkbox">
                                                    <input type="checkbox" id="secondDriver"
                                                        :checked="policyHolder.secondDriver" class="checkbox__checkbox"
                                                        @input="formatCheckbox($event.target.checked, 'secondDriver')" />
                                                    <label for="secondDriver" class="checkbox__label"></label>
                                                </div>
                                            </div>
                                        </div>

                                        <div v-if="offerId == 1" class="form__row">
                                            <div class="form__field">
                                                <Datepicker class="input input--default input--shadow"
                                                    :placeholder="$t(`addOfferModal.driverLicense`)"
                                                    :config="statics.datePickerConfig"
                                                    v-model="policyHolder.driverLicense" />
                                            </div>
                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.approval`)"
                                                    class="input input--default" v-model="policyHolder.approval" />
                                            </div>
                                            <div class="form__field checkbox-field">
                                                <label class="details__option-checkbox" for="secondCar">
                                                    {{ $t(`addOfferModal.secondCar`) }}:
                                                </label>
                                                <div class="checkbox">
                                                    <input type="checkbox" id="secondCar"
                                                        :checked="policyHolder.secondCar" class="checkbox__checkbox"
                                                        @input="formatCheckbox($event.target.checked, 'secondCar')" />
                                                    <label for="secondCar" class="checkbox__label"></label>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <div class="driver-info second-driver-info"
                                        v-if="policyHolder.secondDriver && offerId == 1">
                                        <div class="modal__title">
                                            {{ $t(`addOfferModal.frequentDriver`) }}
                                        </div>

                                        <div class="form__row">
                                            <div class="form__field">
                                                <VSelect class="select select--default"
                                                    :placeholder="$t(`addOfferModal.gender`)" :options="genders"
                                                    :reduce="(gender) => gender.value" :getOptionLabel="(gender) => `${gender.value} `
                                                        " label="name" v-model="secondPolicyHolder.gender" />
                                            </div>
                                            <div class="form__field">
                                                <VSelect class="select select--default"
                                                    :placeholder="$t(`addOfferModal.language`)" :options="languages"
                                                    :reduce="(language) => language.value" :getOptionLabel="(language) => `${language.value} `
                                                        " label="name" v-model="secondPolicyHolder.language" />
                                            </div>
                                            <div class="form__field">
                                                <Datepicker class="input input--default date-picker"
                                                    :config="statics.datePickerConfig"
                                                    :placeholder="$t(`addOfferModal.birthdate`)"
                                                    v-model="secondPolicyHolder.birthdate" />
                                            </div>
                                        </div>

                                        <div class="form__row">
                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.firstName`)"
                                                    class="input input--default"
                                                    v-model="secondPolicyHolder.firstName" />
                                            </div>
                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.lastName`)"
                                                    class="input input--default"
                                                    v-model="secondPolicyHolder.lastName" />
                                            </div>
                                        </div>

                                        <div class="form__row">
                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.phone`)"
                                                    class="input input--default"
                                                    v-model="secondPolicyHolder.phoneNumber" />
                                            </div>
                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.email`)"
                                                    class="input input--default" v-model="secondPolicyHolder.email" />
                                            </div>
                                        </div>

                                        <div class="form__row">
                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.street`)"
                                                    class="input input--default" v-model="secondPolicyHolder.street" />
                                            </div>
                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.zip`)"
                                                    class="input input--default" v-model="secondPolicyHolder.zip" />
                                            </div>
                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.nationality`)"
                                                    class="input input--default"
                                                    v-model="secondPolicyHolder.nationality" />
                                            </div>
                                        </div>

                                        <div class="form__row">

                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.driverLicense`)"
                                                    class="input input--default"
                                                    v-model="secondPolicyHolder.driverLicense" />
                                            </div>

                                            <div class="form__field">
                                                <input type="text" :placeholder="$t(`addOfferModal.approval`)"
                                                    class="input input--default"
                                                    v-model="secondPolicyHolder.approval" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div v-if="currentStep === 3" class="questions-grid">
                                    <div v-for="group in groupedQuestions" :key="group.category.id"
                                        class="question-category" :class="{ 'question-category--table': offerId == 2 }">

                                        <div class="form__label subtitle-label">
                                            {{ group.category[`name_${$i18n.locale}`] || group.category.name }}
                                        </div>

                                        <div class="question-category__questions">
                                            <template v-for="question in group.questions">
                                                <div v-if="shouldShowQuestion(question)" :key="question.id"
                                                    class="form__row dynamic-field"
                                                    :class="{ 'form__row--textarea': question.type === 'textarea', 'form__row--error': validationErrors[question.id] }">
                                                    <div class="form__field">

                                                        <label class="form__label" v-if="question.type !== 'checkbox'">
                                                            {{ question.question_text }}
                                                            <span v-if="question.required"
                                                                class="required-asterisk">*</span>
                                                        </label>

                                                        <input v-if="question.type === 'text'" type="text"
                                                            class="input input--default"
                                                            :placeholder="question.placeholder ? question.placeholder : question.question_text"
                                                            v-model="answers[question.id]"
                                                            @input="clearValidationError(question.id)" />

                                                        <VSelect
                                                            v-else-if="question.type === 'radio' || question.type === 'select'"
                                                            class="select select--default"
                                                            :placeholder="question.placeholder ? question.placeholder : question.question_text"
                                                            :options="question.options || []"
                                                            :reduce="(opt) => opt.value || opt" label="name"
                                                            v-model="answers[question.id]"
                                                            @input="clearValidationError(question.id)" />

                                                        <MultiSelectDropdown v-else-if="question.type === 'multiselect'"
                                                            :items="question.options || []"
                                                            :placeholder="question.placeholder ? question.placeholder : question.question_text"
                                                            label="name" :reduce="(opt) => opt.id || opt"
                                                            :selected="answers[question.id]"
                                                            @input="answers[question.id] = $event; clearValidationError(question.id)" />

                                                        <Datepicker v-else-if="question.type === 'datepicker'"
                                                            class="input input--default input--shadow"
                                                            :placeholder="question.placeholder ? question.placeholder : question.question_text"
                                                            :config="statics.datePickerConfig"
                                                            v-model="answers[question.id]"
                                                            @input="clearValidationError(question.id)" />

                                                        <div v-else-if="question.type === 'checkbox'"
                                                            class="checkbox-container">

                                                            <label class="details__option-checkbox"
                                                                :for="'q-' + question.id">
                                                                {{ question.question_text }}
                                                                <span v-if="question.required"
                                                                    class="required-asterisk">*</span>
                                                            </label>

                                                            <div class="checkbox">
                                                                <input type="checkbox" :id="'q-' + question.id"
                                                                    :checked="answers[question.id] === 1"
                                                                    class="checkbox__checkbox"
                                                                    @change="answers[question.id] = $event.target.checked ? 1 : 0; clearValidationError(question.id)" />

                                                                <label :for="'q-' + question.id"
                                                                    class="checkbox__label"></label>
                                                            </div>
                                                        </div>

                                                        <textarea v-else-if="question.type === 'textarea'"
                                                            class="accident__textarea input input--default" rows="4"
                                                            :placeholder="question.placeholder ? question.placeholder : question.question_text"
                                                            v-model="answers[question.id]"
                                                            @input="clearValidationError(question.id)">
                                                    </textarea>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>

                                    <table class="offer-table" v-if="offerId == 2">
                                        <tr>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.firstName`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.lastName`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.birthdate`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.gender`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.martialStatus`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.insuredNr`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.annualSalary`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.groupOfPersons`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.level`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>{{ $t(`addOfferModal.address`) }}</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>PLZ</p>
                                            </th>
                                            <th class="modal__title">
                                                <p>Ort</p>
                                            </th>
                                            <th></th>
                                        </tr>

                                        <tr v-for="(row, index) in tableRows" :key="row.id">

                                            <td>
                                                <div class="table-input">
                                                    <input type="text" v-model="row.employeeName" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-input">
                                                    <input type="text" v-model="row.employeeSurname" />
                                                </div>
                                            </td>
                                            <td class="date">
                                                <div class="table-input">
                                                    <Datepicker class="input input--default input--shadow"
                                                        :placeholder="$t(`addOfferModal.birthdate`)"
                                                        :config="statics.datePickerConfig"
                                                        v-model="row.employeeBirthdate" />
                                                </div>
                                            </td>
                                            <td style="overflow: visible !important;">
                                                <div class="table-input">
                                                    <VSelect class="select select--default"
                                                        :placeholder="$t(`addOfferModal.gender`)" :options="genders"
                                                        :reduce="(gender) => gender.value" :getOptionLabel="(gender) => `${gender.value} `
                                                            " label="name" v-model="row.employeeGender" />
                                                </div>
                                            </td>
                                            <td style="overflow: visible !important;">
                                                <div class="table-input">
                                                    <VSelect class="select select--default"
                                                        :placeholder="$t(`addOfferModal.martialStatus`)"
                                                        :options="martialStatuses" :reduce="(status) => status.value"
                                                        :getOptionLabel="(status) => `${status.value} `
                                                            " label="name" v-model="row.employeeMartialStatus" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-input">
                                                    <input type="text" v-model="row.employeeInsuredNr" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-input">
                                                    <input type="text" v-model="row.employeeAnnualSalary" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-input">
                                                    <input type="text" v-model="row.employeeGroupOfPersons" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-input">
                                                    <input type="text" v-model="row.employeeLevel" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-input">
                                                    <input type="text" v-model="row.employeeAddress" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-input">
                                                    <input type="text" v-model="row.employeeZip" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-input">
                                                    <input type="text" v-model="row.employeeCity" />
                                                </div>
                                            </td>
                                            <td>
                                                <div class="table-input">
                                                    <div @click="removeRow(index)" class="icon__delete"></div>
                                                </div>
                                            </td>
                                        </tr>
                                    </table>
                                    <button class="button button--default button--animated add-row-button"
                                        @click="addTableRow">
                                        <div class="button__icon"></div>
                                    </button>

                                    <div class="file-upload-section">
                                        <div class="form__label subtitle-label">
                                            Files:
                                        </div>
                                        <DropFile @input="files = $event" :value="files" />
                                    </div>
                                </div>


                                <div v-if="isRequesting"
                                    class="modal__button modal__button--submit button button--default button--loading">
                                </div>
                                <div v-else>
                                    <button class="modal__button modal__button--submit button button--default back-btn"
                                        v-if="currentStep > 1 && !(isEditing && currentStep === 2)" @click="prevStep">
                                        {{ $t(`addOfferModal.${'backBtn'}`) }}
                                    </button>
                                    <button class="modal__button modal__button--submit button button--default"
                                        v-if="currentStep < 3 && offerId" @click="nextStep">
                                        {{ $t(`addOfferModal.${'nextBtn'}`) }}
                                    </button>
                                    <button v-if="currentStep === 3"
                                        class="modal__button modal__button--submit button button--default"
                                        @click="addOffer()">
                                        <span>{{ $t(`addOfferModal.${'saveBtn'}`) }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "@/partials/Loading";
import { parseCustomerName } from "@/helpers/entityParsers";
import { mapGetters } from "vuex";
import statics from "@/statics";
import MultiSelectDropdown from "@/partials/MultiSelectDropdown";

import DropFile from "@/components/DropFile";
export default {
    name: "AddOfferModal",

    components: {
        DropFile,
        Loading,
        MultiSelectDropdown
    },

    data() {
        return {
            lastEmployeeCount: 0,

            parseCustomerName,
            formLoading: true,
            isRequesting: false,
            statics,
            customerId: "",
            teamId: null,
            agentId: null,

            offerId: null,

            nextQuestions: false,

            currentStep: 1,
            isEditing: false,


            policyHolder: {
                agent_id: null,
                gender: null,
                language: null,
                firstName: "",
                lastName: "",
                street: "",
                zip: "",
                birthdate: null,
                driverLicense: "",
                nationality: "",
                approval: "",
                phoneNumber: "",
                email: "",
                secondCar: false,
                secondDriver: false,
                dateOfFundation: null,
                nrOfEmployees: "",
                totalPayroll: "",
                dateOfStart: null,
                duration: "",
            },

            secondPolicyHolder: {
                gender: null,
                language: null,
                firstName: "",
                lastName: "",
                street: "",
                zip: "",
                birthdate: null,
                driverLicense: "",
                nationality: "",
                approval: "",
                phoneNumber: "",
                email: "",
            },


            martialStatusKeys: [
                'single', 'married', 'divorced', 'widowed',
                'registeredPartnership', 'dissolvedPartnership', 'concubinage'
            ],

            languages: [
                { id: 1, value: "EN" },
                { id: 2, value: "DE" },
                { id: 3, value: "IT" },
                { id: 4, value: "FR" },
            ],

            answers: {},
            validationErrors: {},
            files: [],

            tableRows: [],
        };
    },

    watch: {
        mandateTypeId(value) {
            if (value) {
                this.mandateHasError = false;
            } else {
                this.mandateHasError = true;
            }
        },

        answers: {
            deep: true,
            handler(newAnswers) {
                const id = this.employeeCountQuestionId;
                if (!id) return;

                const newCount = parseInt(newAnswers[id]) || 0;

                // ONLY trigger if the number has actually changed
                if (newCount !== this.lastEmployeeCount) {
                    this.lastEmployeeCount = newCount; // Update the tracker
                    this.initializeTable(newCount);    // Only run this when count changes
                }
            }
        },
    },

    computed: {
        ...mapGetters([
            "customerDetails",
            "offerTypes",
            "offerQuestions",
            "loggedUser",
            "offerForms",
            "offerToEdit"
        ]),

        employeeCountQuestionId() {
            const q = this.questions.find(q => q.field_key === "bvg_anzahl_beschaeftigte");
            return q ? q.id : null;
        },

        martialStatuses() {
            return this.martialStatusKeys.map((key, index) => ({
                id: index + 1,
                value: this.$t(`addOfferModal.martialStatuses.${key}`)
            }));
        },

        genders() {
            return ([
                { id: 1, value: this.$t(`addOfferModal.genders.male`) },
                { id: 2, value: this.$t(`addOfferModal.genders.female`) },
                { id: 3, value: this.$t(`addOfferModal.genders.other`) }
            ])
        },

        offers() {
            return this.offerTypes;
        },

        questions() {
            if (this.policyHolder.secondCar) {
                return this.offerQuestions;
            }

            const excludedCategories = [3, 5];

            return this.offerQuestions.filter(
                q => !excludedCategories.includes(q.policy_question_category_id)
            );
        },

        groupedQuestions() {
            const groups = {};

            this.questions.forEach(q => {
                const categoryId = q.category?.id;

                if (!groups[categoryId]) {
                    groups[categoryId] = {
                        category: q.category,
                        questions: []
                    };
                }

                groups[categoryId].questions.push(q);
            });

            Object.values(groups).forEach(group => {
                group.questions.sort((a, b) => a.order - b.order);
            });

            return Object.values(groups).sort(
                (a, b) => a.category.id - b.category.id
            );
        },

        agents() {
            return this.offerForms.agents;
        },

        flatQuestionsMap() {
            const map = {};
            this.groupedQuestions.forEach(group => {
                group.questions.forEach(q => {
                    map[q.field_key] = q.id;
                });
            });
            return map;
        },

        shouldShowQuestion() {
            return (question) => {
                if (!question.show_when_field || !question.show_when_value) return true;

                const depId = this.flatQuestionsMap[question.show_when_field];
                return depId ? this.answers[depId] === question.show_when_value : false;
            };
        },
    },

    async created() {
        this.formLoading = true;

        const customerDetails = this.customerDetails || {};
        const customerTeam = customerDetails.team || {};


        this.teamId = customerTeam.id ? Number(customerTeam.id) : null;
        this.customerId = customerDetails.id || null;
        this.agentId = this.loggedUser?.id || null;

        if (this.teamId) {
            await this.$store.dispatch("getOfferTypes", this.teamId);
            await this.$store.dispatch("getOfferForms", this.teamId);
        }


        if (this.offerToEdit) {
            this.isEditing = true;
            this.currentStep = 2;
            this.offerId = this.offerToEdit.policy_offer?.id || null;

            const customer = this.offerToEdit.customer || {};
            const primaryAddress = customer.customer_addresses?.[0] || {};
            const primaryPhone = customer.customer_phones?.[0] || {};
            const primaryEmail = customer.customer_emails?.[0] || {};

            this.policyHolder = {
                agent_id: this.offerToEdit.agent?.id || null,
                gender: customer.gender?.id || null,
                language: customer.language?.id || null,
                firstName: customer.first_name || "",
                lastName: customer.last_name || "",
                street: primaryAddress.street || "",
                zip: primaryAddress.zip || "",
                birthdate: customer.birthdate || customer.birthday || null,
                driverLicense: this.offerToEdit.driver_license || "",
                nationality: customer.nationality || "",
                approval: this.offerToEdit.approval || "",
                phoneNumber: primaryPhone.phone || primaryPhone.phone_number || "",
                email: primaryEmail.email || "",
                secondCar: !!this.offerToEdit.has_second_car,
                secondDriver: !!this.offerToEdit.has_second_driver,
            };

            if (this.offerToEdit.second_driver) {
                const secondDriver = this.offerToEdit.second_driver;
                this.secondPolicyHolder = {
                    gender: secondDriver.gender?.id || null,
                    language: secondDriver.language?.id || null,
                    firstName: secondDriver.first_name || "",
                    lastName: secondDriver.last_name || "",
                    street: secondDriver.street || "",
                    zip: secondDriver.zip || "",
                    birthdate: secondDriver.birthdate || secondDriver.birthday || null,
                    driverLicense: secondDriver.driver_license || "",
                    nationality: secondDriver.nationality || "",
                    approval: secondDriver.approval || "",
                    phoneNumber: secondDriver.phone_number || secondDriver.telephone || "",
                    email: secondDriver.email || "",
                };
            }

            if (this.offerId) {
                await this.initializeEditQuestions();
            }

            if (this.offerToEdit.files && Array.isArray(this.offerToEdit.files)) {
                this.files = this.offerToEdit.files.map(file => ({
                    name: file.file_name,
                    type: this.parseFileExtension(file.file_name),
                    file: null,
                    id: file.id,
                    isExisting: true,
                }));
            }
        }

        this.formLoading = false;
    },

    destroyed() {
        this.closeModal();
    },

    methods: {
        // initializeTable(nrOfEmployees) {
        //     this.tableRows = [];
        //     const count = parseInt(nrOfEmployees) || 0;
        //     for (let i = 0; i < count; i++) {
        //         this.tableRows.push({
        //             id: i + 1,
        //             employeeName: "",
        //             employeeSurname: "",
        //             employeeBirthdate: "",
        //             employeeGender: "",
        //             employeeMartialStatus: "",
        //             employeeInsuredNr: "",
        //             employeeAnnualSalary: "",
        //             employeeGroupOfPersons: "",
        //             employeeLevel: "",
        //             employeeAddress: "",
        //             employeeZip: "",
        //             employeeCity: "",
        //         });
        //     }
        // },


        initializeTable(count) { 
            if (this.tableRows.length < count) {
                const rowsToAdd = count - this.tableRows.length;
                for (let i = 0; i < rowsToAdd; i++) {
                    this.tableRows.push({  
                        id: Date.now() + Math.random(),
                        employeeName: "",
                        employeeSurname: "",
                        employeeBirthdate: null,
                        employeeGender: null,
                        employeeMartialStatus: null,
                        employeeInsuredNr: "",
                        employeeAnnualSalary: "",
                        employeeGroupOfPersons: "",
                        employeeLevel: "",
                        employeeAddress: "",
                        employeeZip: "",
                        employeeCity: "",
                    });
                }
            } 
            else if (this.tableRows.length > count) {
                this.tableRows = this.tableRows.slice(0, count);
            }
        },

        addTableRow() {
            const length = this.tableRows.length;
            this.tableRows.push({
                id: length + 1,
                employeeName: "",
                employeeSurname: "",
                employeeBirthdate: "",
                employeeGender: "",
                employeeMartialStatus: "",
                employeeInsuredNr: "",
                employeeAnnualSalary: "",
                employeeGroupOfPersons: "",
                employeeLevel: "",
                employeeAddress: "",
                employeeZip: "",
                employeeCity: "",
            });
        },

        removeRow(index) {
            this.tableRows.splice(index, 1);
        },

        async addOffer() {
            if (!this.validateRequiredQuestions()) {
                return;
            }

            this.isRequesting = true;

            const offer = this.buildOfferPayload();

            try {
                let offerId;

                if (this.isEditing && this.offerToEdit?.id) {
                    await this.$store.dispatch("updateCustomerOffer", {
                        offerId: this.offerToEdit.id,
                        offerData: offer,
                        customerId: this.customerId,
                    });
                    offerId = this.offerToEdit.id;
                } else {
                    const response = await this.$store.dispatch("createCustomerOffer", offer);
                    offerId = response?.id;
                }

                if (this.files && this.files.length > 0 && offerId) {
                    const newFiles = this.files
                        .filter(f => !f.isExisting && f.file)
                        .map((file) => file.file);

                    if (newFiles.length > 0) {
                        try {
                            await this.$store.dispatch("addOfferFile", {
                                offerId: offerId,
                                files: newFiles,
                            });
                        } catch (error) {
                            this.$store.commit("setToast", {
                                display: true,
                                type: "error",
                                message: error.response?.data?.message || "Failed to upload files.",
                            });
                        }
                    }
                }

                await this.$store.dispatch("getCustomerOffers", this.customerId);

                this.closeModal();
            } catch (err) {
                console.error("Modal caught error:", err);
            } finally {
                this.isRequesting = false;
            }
        },

        // buildOfferPayload() {
        //     const hasSecondDriver = !!this.policyHolder.secondDriver;
        //     const hasSecondCar = !!this.policyHolder.secondCar;

        //     const payload = {
        //         customer_id: this.customerId,
        //         user_id: this.loggedUser.id,
        //         agent_id: this.policyHolder.agent_id,
        //         policy_offer_id: this.offerId,
        //         team_id: this.teamId,
        //         answers: this.answers,
        //         driver_license: this.policyHolder.driverLicense,
        //         approval: this.policyHolder.approval,
        //         has_second_car: hasSecondCar,
        //         has_second_driver: hasSecondDriver,
        //         second_driver: null,
        //     };

        //     if (hasSecondDriver) {
        //         payload.second_driver = {
        //             gender: this.secondPolicyHolder.gender,
        //             language: this.secondPolicyHolder.language,
        //             birthdate: this.secondPolicyHolder.birthdate,
        //             first_name: this.secondPolicyHolder.firstName,
        //             last_name: this.secondPolicyHolder.lastName,
        //             telephone: this.secondPolicyHolder.phoneNumber,
        //             email: this.secondPolicyHolder.email,
        //             street: this.secondPolicyHolder.street,
        //             zip: this.secondPolicyHolder.zip,
        //             nationality: this.secondPolicyHolder.nationality,
        //             driver_license: this.secondPolicyHolder.driverLicense,
        //             approval: this.secondPolicyHolder.approval,
        //         };
        //     }

        //     return payload;
        // },

        buildOfferPayload() {
            const payload = {
                customer_id: this.customerId,
                user_id: this.loggedUser.id,
                agent_id: this.policyHolder.agent_id,
                policy_offer_id: this.offerId,
                team_id: this.teamId,
                answers: this.answers,
            };

            if (this.offerId == 1) {
                const hasSecondDriver = !!this.policyHolder.secondDriver;

                payload.driver_license = this.policyHolder.driverLicense;
                payload.approval = this.policyHolder.approval;
                payload.has_second_car = !!this.policyHolder.secondCar;
                payload.has_second_driver = hasSecondDriver;

                if (hasSecondDriver) {
                    payload.second_driver = {
                        gender: this.secondPolicyHolder.gender,
                        language: this.secondPolicyHolder.language,
                        birthdate: this.secondPolicyHolder.birthdate,
                        first_name: this.secondPolicyHolder.firstName,
                        last_name: this.secondPolicyHolder.lastName,
                        telephone: this.secondPolicyHolder.phoneNumber,
                        email: this.secondPolicyHolder.email,
                        street: this.secondPolicyHolder.street,
                        zip: this.secondPolicyHolder.zip,
                        nationality: this.secondPolicyHolder.nationality,
                        driver_license: this.secondPolicyHolder.driverLicense,
                        approval: this.secondPolicyHolder.approval,
                    };
                }
            }

            if (this.offerId == 2) {
                payload.employee_list = this.tableRows.map(row => ({
                    name: row.employeeName,
                    surname: row.employeeSurname,
                    birthdate: row.employeeBirthdate,
                    gender: row.employeeGender,
                    martialStatus: row.employeeMartialStatus,
                    insuredNr: row.employeeInsuredNr,
                    annualSalary: row.employeeAnnualSalary,
                    groupOfPersons: row.employeeGroupOfPersons,
                    level: row.employeeLevel,
                    address: row.employeeAddress,
                    zip: row.employeeZip,
                    city: row.employeeCity,
                }));
            }

            return payload;
        },

        formatCheckbox(state, type) {
            if (type === "secondCar") {
                this.policyHolder.secondCar = state;
            } else if (type === "secondDriver") {
                this.policyHolder.secondDriver = state;
            } else {
                this.answers[type] = state ? 1 : 0;
            }
        },

        closeModal() {
            this.$store.commit("setOfferToEdit", null);
            this.$store.commit("setShowAddOfferModal", false);
        },

        goBack() {
            this.closeModal();
            this.$store.commit("setShowAddCustomerServicesModal", true);
        },

        async initializeEditQuestions() {
            this.isRequesting = true;

            try {
                await this.$store.dispatch("getOfferQuestions", this.offerId);

                const questions = Array.isArray(this.offerQuestions) ? this.offerQuestions : [];
                const initialAnswers = this.buildDefaultAnswers();
                const typeMap = questions.reduce((acc, question) => {
                    acc[question.id] = question.type;
                    return acc;
                }, {});

                if (Array.isArray(this.offerToEdit.answers)) {
                    this.offerToEdit.answers.forEach(answer => {
                        const questionId = answer.question?.id;

                        if (!questionId || initialAnswers[questionId] === undefined) {
                            return;
                        }

                        const questionType = typeMap[questionId];
                        initialAnswers[questionId] = this.normalizeAnswerValue(answer.answer_value, questionType);
                    });
                }

                this.answers = initialAnswers;
            } finally {
                this.isRequesting = false;
            }
        },

        buildDefaultAnswers() {
            const defaults = {};

            if (!Array.isArray(this.offerQuestions)) {
                return defaults;
            }

            this.offerQuestions.forEach(question => {
                defaults[question.id] = this.getDefaultAnswerValue(question.type);
            });

            return defaults;
        },

        getDefaultAnswerValue(type) {
            if (type === "checkbox" || type === "multiselect") {
                return [];
            }

            return null;
        },

        normalizeAnswerValue(value, type) {
            if (value === null || value === undefined) {
                return value;
            }

            if (type === "checkbox") {
                if (typeof value === "boolean") {
                    return value ? 1 : 0;
                }

                if (value === "true" || value === "false") {
                    return value === "true" ? 1 : 0;
                }

                const numericValue = Number(value);

                if (!Number.isNaN(numericValue)) {
                    return numericValue;
                }

                return value;
            }

            if (type === "multiselect") {
                if (Array.isArray(value)) {
                    return value;
                }

                if (typeof value === "string") {
                    try {
                        const parsedValue = JSON.parse(value);

                        if (Array.isArray(parsedValue)) {
                            return parsedValue;
                        }
                    } catch (error) {
                        return value ? [value] : [];
                    }
                }
            }

            return value;
        },

        async getQuestions(id) {
            this.formLoading = true;
            this.isRequesting = true;
            await this.$store.dispatch("getOfferQuestions", id);

            this.answers = this.buildDefaultAnswers();

            this.customerDetails;

            const customerDetails = this.customerDetails || {};
            const primaryAddress = customerDetails.customer_addresses?.[0] || {};
            const primaryPhone = customerDetails.customer_phones?.[0] || {};
            const primaryEmail = customerDetails.customer_emails?.[0] || {};

            this.policyHolder.gender = customerDetails.gender?.id || null;
            this.policyHolder.language = customerDetails.language?.id || null;
            this.policyHolder.firstName = customerDetails.first_name || "";
            this.policyHolder.lastName = customerDetails.last_name || "";
            this.policyHolder.birthdate = customerDetails.birthday || null;
            this.policyHolder.nationality = customerDetails.country || "";
            this.policyHolder.street = primaryAddress.street || "";
            this.policyHolder.zip = primaryAddress.zip || "";
            this.policyHolder.phoneNumber = primaryPhone.phone || primaryPhone.phone_number || "";
            this.policyHolder.email = primaryEmail.email || "";

            this.formLoading = false;
            this.isRequesting = false;
            this.currentStep = 2;
        },

        nextStep() {
            if (this.currentStep < 3) this.currentStep++;

        },

        prevStep() {
            if (this.currentStep > 1) this.currentStep--;
        },

        validateRequiredQuestions() {
            this.validationErrors = {};
            let isValid = true;

            this.questions.forEach(question => {
                if (question.required) {
                    const answer = this.answers[question.id];

                    if (question.type === 'multiselect') {
                        if (!answer || !Array.isArray(answer) || answer.length === 0) {
                            this.validationErrors[question.id] = true;
                            isValid = false;
                        }
                    } else if (question.type === 'checkbox') {
                        if (answer !== 1 && answer !== true) {
                            this.validationErrors[question.id] = true;
                            isValid = false;
                        }
                    } else {
                        if (answer === null || answer === undefined || answer === '') {
                            this.validationErrors[question.id] = true;
                            isValid = false;
                        }
                    }
                }
            });

            if (!isValid) {
                this.$store.commit("setToast", {
                    display: true,
                    type: "error",
                    message: this.$t('addOfferModal.requiredFieldsError') || 'Please fill in all required fields',

                });
            }

            return isValid;
        },

        clearValidationError(questionId) {
            if (this.validationErrors[questionId]) {
                this.$set(this.validationErrors, questionId, false);
            }
        },

        parseFileExtension(name) {
            const mimeTypeParts = name.split(".");
            let mimeType = mimeTypeParts[mimeTypeParts.length - 1].toLowerCase();
            if (mimeType === "jpg" || mimeType === "png" || mimeType === "svg") {
                mimeType = "image";
            }
            return mimeType;
        },
    },
};
</script>

<style scoped lang="scss">
@import "../assets/scss/_termination-potential-policy.scss";

.offer-subtitle {
    margin-bottom: 10px;
}

.add-row-button {
    border-radius: 50%;
    width: 48px;
    transform: scale(0.7);
    box-shadow: none;
    margin: 0 auto;
}

.table-input {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 40px;

    input {
        color: var(--text-2);
        background: transparent;
    }
}

td,
th {
    border: 1px solid #ddd;
    padding: 8px;
}


///

table {
    table-layout: fixed;
    width: 100%;
    border-collapse: collapse;
    overflow: visible;
}

td,
th {
    padding: 4px;
    border: 1px solid #ddd;
    overflow: hidden;
    font-size: 14px;

    input,
    .input--default,
    .select--default {
        font-size: 12px;
    }
}

td input {
    width: 100%;
    box-sizing: border-box;
    border: none;
    padding: 4px;
}



th:nth-child(12) {
    width: 50px;
}

th:nth-child(13) {
    width: 30px;
}


.drop .files {
    width: 25% !important;
    margin: 0 auto !important;
}

.drop {
    margin: 0 auto;
}

.modal .form {
    //height: 95% !important;
    overflow: auto !important;
}

.form-selection-row {
    width: 50%;
    margin: 0 auto;
    margin-top: 30px;
}

.modal__panel {
    max-width: 1010px !important;
    width: 1010px !important;
    min-height: 400px !important;

    // overflow: hidden;
}

.modal__panel--table {
    max-width: 1600px !important;
    width: 1600px !important;
    height: 800px !important;
}

.modal__panel--questions {
    height: 800px !important;
}

.question-category--table {
    width: 68%;
    margin-left: auto;
    margin-right: auto;
}


.form__field {
    width: 100% !important;
}

.modal__title {
    color: var(--text-1);
    font-family: var(--muli-text-semi-bold);
    margin-bottom: 10px;
    color: var(--text-5);
}

.details__option-checkbox,
.form__field {
    //margin-right: 10px;
    color: var(--text-8);
    font-size: 1em;
}

.details__option-checkbox {
    margin-right: 10px;
}

.form__label {
    margin-bottom: 10px;
}

.checkbox-field {
    display: flex;
    align-items: center;
}

.questions-wrapper,
.driver-info {
    margin-top: 30px;
}

.add__form {
    width: 100% !important;
}

.icon__delete {
    width: 20px;
    height: 20px;
    margin: auto;
    cursor: pointer;
}

.required-asterisk {
    color: var(--red, #e74c3c);
    margin-left: 4px;
    font-weight: bold;
}

.form__row--error {

    .input,
    .select,
    .checkbox__checkbox {
        border-color: var(--red, #e74c3c) !important;
    }

    .form__label {
        color: var(--red, #e74c3c);
    }
}

.custom-duration-wrapper {

    background-color: var(--bg-3);

    color: var(--text-3);
    padding: 0 10px;
    font-size: var(--x-small);
    border-radius: var(--radius-1);
    font-family: var(--muli-text-semi-bold);
    border: 1px solid transparent;


    display: flex;
    align-items: center;
    padding: 0;

}

.custom-duration {
    background-color: transparent;
    //  border: 1px solid ;
    height: 40px;
    color: var(--text-3);

    font-size: var(--x-small);
    text-align: center;
    font-family: var(--muli-text-semi-bold);
}


::v-deep .vue__time-picker input.display-time {
    width: 100%;
    padding: .3em .5em;
    font-size: 1em;
    height: 100%;
    background-color: transparent;
    border: none;
    text-align: center;
    color: var(--text-2);
    font-family: var(--muli-text-semi-bold);
}

.form__row {
    border: 0;
    gap: 15px;
}

.form__field__call__duration {
    margin-top: -8px;
}

.call__duration__label {
    margin-bottom: -6px;
}

[data-theme="dark"] .call__duration__label {
    p {
        color: white;
    }
}


.call__duration__label p {
    color: #7F8FA480;
    font-size: 14px;
}


.call__duration__types {
    display: flex;
    gap: 12px;
}


.call__duration__value {
    color: #B9C2CD;
    font-size: 16px;
    cursor: pointer;
}


.call__duration__value--active {
    color: #22DB8E;
}

.form__textarea__row {
    margin-top: -40px;
}

.form__notes__textarea {
    width: 66%;
}


.custom-time-input {
    position: relative;
    width: 48%;
}

.custom-input {
    appearance: none;
    color: var(--text-2);
    background-color: var(--bg-3);
    border-radius: 10px;
    padding: 0 10px;
    height: 40px;
    font-size: 16px;
    width: 100%;
    box-sizing: border-box;
}

.custom-input::placeholder {
    font-family: var(--muli-text-semi-bold);
    color: var(--text-8);
}


.date-picker {
    width: 48%;
    position: relative;
    z-index: 1;
}

.date-time-wrapper {
    display: flex;
    justify-content: space-between;
}


.questions-grid {
    .form__field {
        margin-bottom: 0 !important;
    }
}

.question-category {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-bottom: 30px;
}

.question-category__title {
    font-family: var(--muli-text-semi-bold);
    font-size: 16px;
}

.question-category__questions {
    display: grid;
    // grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    grid-template-columns: repeat(2, 1fr);
    gap: 16px 20px;
    width: 100%;
}

.form__row--textarea {
    // grid-column: auto;
    // width: 100%;
    grid-column: span 2;
}

.form__row--textarea .form__field {
    display: flex;
    flex-direction: column;
    width: 100%;
}

.form__label {
    display: block;
}

.accident__textarea {
    width: 100%;
    resize: vertical;

    width: 100% !important;
    max-width: none !important;
}

.dynamic-field {
    display: block;
    background-color: transparent;
    border: 1px solid #eef1f5;
    border-radius: 12px;
    padding: 10px;
    box-shadow: none;
    transition: border-color 120ms ease, box-shadow 120ms ease;
}

.dynamic-field:focus-within {
    border-color: #21d488;
    box-shadow: 0 8px 30px rgba(33, 212, 136, 0.12);
}

.dynamic-field .form__label {
    margin-bottom: 6px;
    font-size: var(--x-small);
    color: var(--text-5);
    letter-spacing: 0.01em;
}

.dynamic-field .checkbox-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.form__row--textarea .dynamic-field {
    padding: 14px 16px;
}

.accident__textarea {
    min-height: 64px;
}

.back-btn {
    right: 0;
    left: 80px;
}

.subtitle-label {
    color: #4870a480;
    font-family: var(--muli-text-semi-bold);
    font-size: 1em;
}

[data-theme="dark"] .subtitle-label {
    color: white;
}


.second-driver {
    font-size: 0.95em;
}

.file-upload-section {
    margin-top: 30px;
    padding-top: 20px;
    border-top: 1px solid var(--bg-5);
}

.file-upload-section .subtitle-label {
    margin-bottom: 15px;
}

@media (min-width: 2470px) {

    .modal__panel--table,
    .modal__panel--questions {
        height: 1000px !important;
    }
}

@media(min-width: 3200px) {

    .modal__panel--table,
    .modal__panel--questions {
        height: 1200px !important;
    }
}

@media (max-width: 768px) {
    .question-category__questions {
        grid-template-columns: 1fr;
    }

    .form__row--textarea {
        grid-column: span 1;
    }
}
</style>